<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u64P8M/tc-custom/9780802197702.jpg?1695308093700" alt="This image is the cover for the book I'll Steal You Away"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'll Steal You Away
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling author of <i>I’m Not Scared</i> “beautifully evokes the lopsided streets of an Italian backwater . . . the shadow life of childhood” (<i>The New Yorker</i>).</b><br/>  <br/> Italian literary superstar Niccolò Ammaniti’s novel, <i>I’m Not Scared, </i>prompted gushing praise, hit international bestseller lists, and was made into a smash indie film. In <i>I’ll Steal You Away</i>, Ammaniti takes his unparalleled empathy for children, his scythe-sharp observations, and his knack for building tension to a whole new level. In a tiny Italian village, a young boy named Pietro is growing up tormented by bullies and ignored by his parents. When an aging playboy, Graziano Biglia, returns to town, a change is in the air: Pietro decides to take on the bullies, his lonely teacher Flora finds romance with the town’s prodigal son, and the inept janitor at the school proclaims his love for his favorite prostitute. But the village isn’t ready for such change, and when Graziano seduces and forgets Flora, both she and Pietro’s tentative hopes seem crushed forever. With great tenderness, Ammaniti shines light on the heart-wrenching failures and quiet redemptions of ordinary people trying to live extraordinary lives.<br/>  <br/> “Deliciously languorous . . . Ammaniti has a Dickensian touch for character study . . . <i>I’ll Steal You Away</i> will do just that.” —<i>The New York Times Book Review</i><br/>  <br/> “A snapshot of small-town Italian life that could be, just as easily, a tale of small-town American life . . . Ammaniti weaves almost seamlessly between his characters as they spiral slowly toward their inevitable sad conclusions. A-” —<i>Entertainment Weekly</i><br/>  <br/> “Chilling and intimate, Ammaniti’s work brings life to a deceptively quiet town and its wealth of eclectic and unsettling residents.” —<i>Publishers Weekly</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Niccolò Ammaniti
      </h2>
      
      <p class="authorDescription body article">Niccolò Ammaniti is an Italian writer, winner of the Premio Strega on 2007 for As God Commands. He became noted in 2001 with the publication of I'm Not Scared, a novel which was later made into a movie directed by Gabriele Salvatores.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a1c4e58